import { AnyAction } from 'redux';
import { IAppState } from '../types/state.d';
import { apiActionTypes } from '../actions/actionCreators/actionTypes';

const teamlocksReducer = (
  state: IAppState['teamlocks'] = null,
  { type, payload }: AnyAction,
): IAppState['teamlocks'] => {
  switch (type) {
    case apiActionTypes.LOCKS_REQUEST_SUCCESS:
    case apiActionTypes.UPDATE_LOCKS_REQUEST_SUCCESS:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default teamlocksReducer;
